// extracted by mini-css-extract-plugin
export default {"cardFooter":"style_cardFooter__m+jUG","cardFooterBell":"style_cardFooterBell__u6BYM","chevron":"style_chevron__2RKI4"};